import axios from 'axios'
import Const from '../const'

const authMixin = {
  created() {

    axios.post(Const.BASE_URL + '/authentication', "", {
      headers: {
        "Authorization": this.$store.getters.token,
        "Content-Type": "application/json"
        }
    })
    .then(function() {
      // console.log(response)
      if (!this.$store.getters.isLoginFlag) {
        this.$router.push({ name: "login" })
      }
    }.bind(this))
    .catch(function() {
      // console.log(error)
      this.$store.dispatch("updateTokenError", true)
      this.$router.push({ name: "login" })
    }.bind(this))
  }
}

export default authMixin
